__turbopack_context__.v({
  "categoryBlock": "index-module-scss-module__gBwx2a__categoryBlock",
  "categoryHeader": "index-module-scss-module__gBwx2a__categoryHeader",
  "cellChange": "index-module-scss-module__gBwx2a__cellChange",
  "cellDate": "index-module-scss-module__gBwx2a__cellDate",
  "cellFav": "index-module-scss-module__gBwx2a__cellFav",
  "cellName": "index-module-scss-module__gBwx2a__cellName",
  "cellPrice": "index-module-scss-module__gBwx2a__cellPrice",
  "changeDown": "index-module-scss-module__gBwx2a__changeDown",
  "changeFlat": "index-module-scss-module__gBwx2a__changeFlat",
  "changeUp": "index-module-scss-module__gBwx2a__changeUp",
  "code": "index-module-scss-module__gBwx2a__code",
  "colChange": "index-module-scss-module__gBwx2a__colChange",
  "colDate": "index-module-scss-module__gBwx2a__colDate",
  "colFav": "index-module-scss-module__gBwx2a__colFav",
  "colName": "index-module-scss-module__gBwx2a__colName",
  "colPrice": "index-module-scss-module__gBwx2a__colPrice",
  "currencySwitch": "index-module-scss-module__gBwx2a__currencySwitch",
  "favBtn": "index-module-scss-module__gBwx2a__favBtn",
  "favOff": "index-module-scss-module__gBwx2a__favOff",
  "favOn": "index-module-scss-module__gBwx2a__favOn",
  "header": "index-module-scss-module__gBwx2a__header",
  "nameLink": "index-module-scss-module__gBwx2a__nameLink",
  "price": "index-module-scss-module__gBwx2a__price",
  "row": "index-module-scss-module__gBwx2a__row",
  "table": "index-module-scss-module__gBwx2a__table",
  "tableWrap": "index-module-scss-module__gBwx2a__tableWrap",
  "text": "index-module-scss-module__gBwx2a__text",
  "title": "index-module-scss-module__gBwx2a__title",
  "unit": "index-module-scss-module__gBwx2a__unit",
  "wrap": "index-module-scss-module__gBwx2a__wrap",
});
